import toString from './to-string';

const lowerCase = function(str: string): string {
  return toString(str).toLowerCase();
};

export default lowerCase;
